import { request } from '../request';

export interface LoginFormDto {
  account: string;
  captchaVO?: string;
  pwd: string;
}
export function fetchLogin(data: LoginFormDto) {
  return request<Api.Auth.LoginToken>({
    data,
    method: 'post',
    url: '/platform/login'
  });
}

/** Get user info */
export function fetchGetUserInfo() {
  return request<Api.Auth.UserInfo>({ url: '/platform/getAdminInfoByToken' });
}

/**
 * Refresh token
 *
 * @param refreshToken Refresh token
 */
export function fetchRefreshToken(refreshToken: string) {
  return request<Api.Auth.LoginToken>({
    data: {
      refreshToken
    },
    method: 'post',
    url: '/auth/refreshToken'
  });
}

/**
 * return custom backend error
 *
 * @param code error code
 * @param msg error message
 */
export function fetchCustomBackendError(code: string, msg: string) {
  return request({ params: { code, msg }, url: '/auth/error' });
}
